import { Route, Routes } from 'react-router';
import { Languages } from './languages';
import { StaticTranslationKeyEditor } from './static-translation-key-editor';
import { StaticTranslationKeys } from './static-translation-keys';

export const Internationalization = (): JSX.Element => {
  return <Routes>
    <Route path="/" element={<Languages />} />
    <Route path="/static-translation-keys" element={<StaticTranslationKeys />} />
    <Route path="/static-translation-keys/:id" element={<StaticTranslationKeyEditor />} />
  </Routes>;
};
